import { Component, createApp } from 'vue'
import { camelize } from 'casing'
import { plugins, directives, components as globalComponents } from './plugins'
import { key, store } from './store'

export function mountComponent (components: {[key: string]: Component}) {
  document.addEventListener('DOMContentLoaded', () => {
    const elems = document.querySelectorAll('[data-component]') as NodeListOf<HTMLElement>

    elems.forEach(elem => {
      const componentName = elem.dataset.component
      const props = camelize(JSON.parse(elem.dataset.props || '{}'))

      if (componentName) {
        const Component = components[componentName]

        const app = createApp(Component, props)

        // Register plugins
        plugins.forEach(p => app.use(p))
        // Store plugin need to set the key for use inject which requires for typing.
        // So need to register it separately.
        app.use(store, key)

        // Register directives
        for (const key in directives) {
          app.directive(key, directives[key])
        }

        // Register Components
        for (const key in globalComponents) {
          app.component(key, globalComponents[key])
        }

        app.mount(elem)
      }
    })
  })
}
